import { POST_SUMMARY_CHAR_LENGTH } from "@hubcapp/constants";
import { PostType } from "@hubcapp/types";
import { parsePostContent } from "@hubcapp/utils";

export const getPostSummary = (content: string) =>
  parsePostContent(content.substr(0, POST_SUMMARY_CHAR_LENGTH));

export const getUrlExtentionForNewsItem = (type: PostType) => {
  switch (type) {
    case PostType.Tech:
      return "tech-updates";
    default:
      return "news";
  }
};
